import Vue from 'vue'
import _ from 'lodash'
import {request} from '@/utils/request'

class EffectFunction {
    constructor() {
        
    }
    setVisible = (target, value) => {
        target.formState.payload.props.visible = value;
        // if (!value) {
        //     Vue.nextTick(() => {
        //         if (Array.isArray(target.formState.payload.value)) {
        //             target.formState.payload.value = [];
        //         } else {
        //             target.formState.payload.value = null;
        //         }
        //     });
        // }
    }
    setValue = (target, value) => {
        Vue.set(target.formState.payload, 'value', value);
    }
    setDisabled = (target, value) => {
        target.formState.payload.props.disabled = value;
    }
    setRules = (target, value) => {
        target.formState.payload.rules = value;
    }
    fetchOptions = async (target, config) => {
        const { fetch_url,fetch_type, params, field } = config;
        try {
            // 显示加载状态
            target.formState.payload.props.loading = true;
    
            let filter_params = _.pick(target.rootFormData, params || []);
            console.log('filter_params', filter_params);
            // 调用接口获取数据
            if (!fetch_url || !fetch_type) {
                new Error('url or type is required');
            }
    
            const requestConfig = {
                url: fetch_url,
                method: fetch_type
            };
            if (fetch_type === 'get') {
                requestConfig.params = filter_params;
            } else if (fetch_type === 'post') {
                requestConfig.data = filter_params;
            }
            const response = await request(requestConfig);

            console.log('response', response);
            let resList = response.data.splice(0, 3).map(item => {
                return {
                    label: item.company_name,
                    value: item.customer_id
                }
            }) || [];
            console.log('resList', resList);
            // 更新选项
            target.formState.payload.props.defaultData = resList;
    
            // 如果有默认值，可以在这里处理
            if (config.defaultValue) {
                target.formState.payload.value = config.defaultValue;
            }
        } catch (error) {
            console.error('获取选项失败:', error);
        } finally {
            target.formState.payload.props.loading = false;
        }
    }
    updateConfigOptions = (target, config) => {
        const { pathFields, field } = config;
        let configs = window.batch_config_wk;
        
        // 根据value值找到对应的param_id
        const path = pathFields.map(field => {
            const value = target.rootFormData[field];
            // 从configs中找到对应字段的配置数组
            const configArray = configs[field] || [];
            const item = configArray.find(item => item.value === value);
            return item ? item.param_id : value;
        }).filter(Boolean).join('_');

        console.log(path, 'path')
        const getOptionsByPath = (array, path) => {
            const items = array.filter(item => item.pid === path);
            return items
        }
        // 获取选项
        const options = getOptionsByPath(configs[field], path);
        console.log(options, 'options', target.formState.type)
        if (options.length > 0) {
            // 有选项则更新
            target.formState.payload.props.defaultData = options;
            target.formState.payload.props.visible = true;
            if(target.formState.type == 'WkRadioGroup'){
                target.formState.payload.value = options[0].value;
            }
        } else {
            // 无选项则隐藏或清空
            if (config.hideWhenEmpty) {
                target.formState.payload.props.visible = false;
            }
            if (config.clearWhenEmpty) {
                target.formState.payload.value = Array.isArray(target.formState.payload.value) ? [] : '';
            }
        }
    }
    openDrawer = (target, config) => {
        const { component, options, props, cbs, on } = config;
        console.log('openDrawer', component, options, props, cbs, on);
    }
}
export const EffectFunctionInstance = new EffectFunction();
class HuaweiAdsEffectFunction extends EffectFunction {
    constructor() {
        super();
    }
    setVisible = (target, value) => {
        super.setVisible(target, value); // 调用父类的方法
        // 额外的逻辑 或 改写原方法
    }
}
const { setVisible, setValue, setDisabled, setRules, fetchOptions, updateConfigOptions, openDrawer } = new EffectFunction();
// 导出处理器对象 基础处理器 后续需要更改 其他媒体不同逻辑 可以走继承改变原方法逻辑 EffectFunctionInstance 或者 自行扩展 
export const effectHandlers = {
    setVisible: setVisible,
    setValue: setValue,
    setDisabled: setDisabled,
    setRules: setRules, 
    fetchOptions: fetchOptions,
    updateConfigOptions: updateConfigOptions,
    openDrawer: openDrawer,
};